
import React from 'react'
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch, useSelector } from "react-redux";
const textStyles = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "24px",
 fontWeight: "500",
 wordBreak: 'break-word', overflowWrap: 'break-word',


};
export default function Header({ flag }) {
 const navigate = useNavigate();
 const dispatch = useDispatch();
 const { cmrIsGoBack, getKeyTagExpert } = bindActionCreators(Actions, dispatch)
 const onGoBack = () => {
   getKeyTagExpert(null)
   setTimeout(() => {
     cmrIsGoBack(false);
   }, 2000);
   // navigate('/cmHome/expertRecords/');
   navigate('/cmHome/expertResponses/');
 }
 return (
   <div style={{ display: 'flex', alignItems: 'end' }}>
     <div style={{ width: '30%' }}>


     </div>
     <div style={{
       width: '40%', fontSize: "16px",
       color: "#2A364A", fontWeight: "400", textAlign: 'center', paddingTop: "10px"
     }}>
       <span style={{ fontSize: '22px' }}>Record Details</span>
     </div>
     {/* <div style={{width:'30%', textAlign:'end'}}>
       <CloseOutlined onClick={()=>onGoBack()} style={{fontSize:'24px',cursor:'pointer'}}/>
       </div> */}
     {/* <span style={{float:'inline-end'}}>
       <CloseOutlined style={{fontSize:'26px', fontWeight:'bold'}}/>
       </span> */}
   </div>
 )
}
